/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Upfront_RowInputs */

const en_case_payment_upfront_row = /** @type {(inputs: Case_Payment_Upfront_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upfront`)
};

const pt_br2_case_payment_upfront_row = /** @type {(inputs: Case_Payment_Upfront_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À vista`)
};

/**
* | output |
* | --- |
* | "Upfront" |
*
* @param {Case_Payment_Upfront_RowInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_upfront_row = /** @type {((inputs?: Case_Payment_Upfront_RowInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Upfront_RowInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_upfront_row(inputs)
	return pt_br2_case_payment_upfront_row(inputs)
});